import { SimulatePriceSuccessPayload, SimulationActionTypes } from 'store/simulation/actions/types'

export const START_SIMULATION = 'SIMULATION/START_SIMULATION'
export const SIMULATE_PRICE_SUCCESS = 'SIMULATION/SIMULATE_PRICE_SUCCESS'
export const SIMULATE_PRICE_ERROR = 'SIMULATION/SIMULATE_PRICE_ERROR'

export const startSimulation = (): SimulationActionTypes => {
  return { type: START_SIMULATION }
}

export const simulatePriceSuccess = ({ simulatedPrice }: SimulatePriceSuccessPayload): SimulationActionTypes => {
  return { type: SIMULATE_PRICE_SUCCESS, simulatedPrice }
}

export const simulatePriceError = (): SimulationActionTypes => {
  return { type: SIMULATE_PRICE_ERROR }
}
